import axios, { AxiosError } from "axios";
import { deleteTokenCookie, getTokenCookie, setTokenCookie, tokensPortal } from "@/libs/cookie";
import { atualizarTokenAccessRequest } from "./auth";
import { config } from "@/config";

export const apiPortal = axios.create({
  baseURL: config.apiUrl,
  headers: {
    "Content-Type": "application/json",
  },
});

apiPortal.interceptors.request.use((config) => {
  const tokenAccess = getTokenCookie(tokensPortal.access);

  if (tokenAccess) {
    config.headers.Authorization = `Bearer ${tokenAccess}`;
  }

  return config;
});

apiPortal.interceptors.response.use(
  (response) => { return response; },
  (error: AxiosError) => {
    if(
      error.response?.config?.url?.includes("/api/portal/contribuintes/token-refresh") || 
      error.response?.config?.url?.includes("/api/portal/contribuintes/login")
    ){
      return Promise.reject(errorHandler(error));
    }

    // check conditions to refresh token
    if ( error.response?.status === 401 ) {
      return refreshToken(error);
    }

    return Promise.reject(errorHandler(error));
  }
);

let fetchingToken = false;
let subscribers: ((token: string) => any)[] = [];

const onAccessTokenFetched = (token: string) => {
  subscribers.forEach((callback) => callback(token));
  subscribers = [];
};

const addSubscriber = (callback: (token: string) => any) => {
  subscribers.push(callback);
};

const logout = ()=>{
  deleteTokenCookie(tokensPortal.refresh);
  deleteTokenCookie(tokensPortal.access);

  window.location.href = '/portal/login';
}
 
//
// Atualiza token caso chamada retorna 401
//
const refreshToken = async (oError: AxiosError) => {
  try {
    console.log('refreshToken');
    
    const { response } = oError;

    // Cria uma nova promessa para tentar novamente a solicitação original
    const retryOriginalRequest = new Promise((resolve) => {
      addSubscriber((token: string) => {
        response!.config.headers["Authorization"] = `Bearer ${token}`;
        resolve(axios(response!.config));
      });
    });

    // Verifica se está atualizando ou não o token
    if (!fetchingToken) {
      fetchingToken = true;

      // Busca token de refresh nos cookies
      let tokenRefresh = getTokenCookie(tokensPortal.refresh);
      
      // Redireciona para logout por nao exitir token de atualizacao
      if(!tokenRefresh) logout();
      
      // Atualiza token de acesso com token de refresh.
      const tokenAccess = await atualizarTokenAccessRequest(tokenRefresh);
      setTokenCookie(tokensPortal.access, tokenAccess);

      // when new token arrives, retry old requests
      onAccessTokenFetched(tokenAccess);
    }

    return retryOriginalRequest;
  } catch (error:any) {
    if(error?.status == 401){
      logout();
    }

    return Promise.reject(error);
  } finally {
    fetchingToken = false;
  }
};

export type ErrorApi  = {
  success: boolean;
  data: any | { message: string },
  status: number
}

export const errorHandler = (error: any):ErrorApi =>  {
  const response = error.response;
  return {
    success: false,
    data: response?.data || { message: "Ops! Ocorreu um erro. Tente Novamente!" },
    status: response?.data?.status || response?.status,
  };
};
